//SETTING
export const AUTH_USER = "AUTH_USER";
export const GET_USER = "GET_USER";
export const FIND_USER = "FIND_USER";

export const GET_SYSTEM_ROLE = "GET_SYSTEM_ROLE";
export const FIND_SYSTEM_ROLE = "FIND_SYSTEM_ROLE";

export const GET_TYPE_TRAVEL = "GET_TYPE_TRAVEL";
export const FIND_TYPE_TRAVEL = "FIND_TYPE_TRAVEL";

export const GET_PRIVACY = "GET_PRIVACY";
export const FIND_PRIVACY = "FIND_PRIVACY";

export const GET_NATIONALITY = "GET_NATIONALITY";
export const GET_INFINITE_NATIONALITY = "GET_NATIONALITY";
export const FIND_NATIONALITY = "FIND_NATIONALITY";

export const GET_INFINITE_CONTACT = "GET_INFINITE_CONTACT";
export const GET_CONTACT = "GET_CONTACT";
export const FIND_CONTACT = "FIND_CONTACT";

export const GET_ICON = "GET_ICON";
export const FIND_ICON = "FIND_ICON";

export const GET_TYPE_OF_VISIT = "GET_TYPE_OF_VISIT";
export const FIND_TYPE_OF_VISIT = "FIND_TYPE_OF_VISIT";

export const GET_SLIDE = "GET_SLIDE";
export const GET_INFINITE_SLIDE = "GET_INFINITE_SLIDE";
export const FIND_SLIDE = "FIND_SLIDE";

//FormData
export const GET_TICKET_SALE = "GET_TICKET_SALE";
export const RETRIEVE_TICKET_SALE = "RETRIEVE_TICKET_SALE";
export const GET_TICKET_SALE_REPORT_DATA = "GET_TICKET_SALE_REPORT_DATA";

export const GET_TOURIST_BY_NATIONALITY = "GET_TOURIST_BY_NATIONALITY";
export const RETRIEVE_TOURIST_BY_NATIONALITY = "RETRIEVE_TOURIST_BY_NATIONALITY";

export const GET_TOURIST_BY_AGENT = "GET_TOURIST_BY_AGENT";
export const RETRIEVE_TOURIST_BY_AGENT = "RETRIEVE_TOURIST_BY_AGENT";
export const GET_TOURIST_BY_AGENT_REPORT_DATA =
  "GET_TOURIST_BY_AGENT_REPORT_DATA";

export const RETRIEVE_TOURIST_EACH_TEMPLE = "RETRIEVE_TOURIST_EACH_TEMPLE";
export const GET_TOURIST_EACH_TEMPLE = "GET_TOURIST_EACH_TEMPLE";
export const GET_TOURIST_EACH_TEMPLE_REPORT_DATA =
  "GET_TOURIST_EACH_TEMPLE_REPORT_DATA";

//Temple
export const GET_TEMPLE = "GET_TEMPLE";
export const GET_INFINITE_TEMPLE = "GET_INFINITE_TEMPLE";
export const FIND_TEMPLE = "FIND_TEMPLE";

export const GET_INFINITE_TEMPLE_GROUP = "GET_INFINITE_TEMPLE_GROUP";
export const GET_TEMPLE_GROUP = "GET_TEMPLE_GROUP";
export const FIND_TEMPLE_GROUP = "FIND_TEMPLE_GROUP";

//MoreThanTemple
export const GET_ANNUAL_EVENT = "GET_ANNUAL_EVENT";
export const FIND_ANNUAL_EVENT = "FIND_ANNUAL_EVENT";
export const FIND_THUMBNAIL = "FIND_THUMBNAIL";
export const GET_INFINITE_ANNUAL_EVENT = "GET_INFINITE_ANNUAL_EVENT";

export const GET_MUSEUM = "GET_MUSEUM";
export const FIND_MUSEUM = "FIND_MUSEUM";
export const GET_INFINITE_MUSEUM = "GET_INFINITE_MUSEUM";

export const GET_COMMUNITY = "GET_COMMUNITY";
export const FIND_COMMUNITY = "FIND_COMMUNITY";
export const GET_INFINITE_COMMUNITY = "GET_INFINITE_COMMUNITY";

export const GET_ACTIVITY = "GET_ACTIVITY";
export const FIND_ACTIVITY = "FIND_ACTIVITY";
export const GET_INFINITE_ACTIVITY = "GET_INFINITE_ACTIVITY";

//Others
export const GET_FEED = "GET_FEED";
export const GET_INFINITE_FEED = "GET_INFINITE_FEED";
export const FIND_FEED = "FIND_FEED";

export const GET_ZONES = "GET_ZONES";
export const FIND_ZONE = "FIND_ZONE";

//CodeConduct
export const GET_CODE_OF_CONDUCT = "GET_CODE_OF_CONDUCT";
export const FIND_CODE_OF_CONDUCT = "FIND_CODE_OF_CONDUCT";
export const FIND_DESCRIPTION = "FIND_DESCRIPTION";
export const GET_INFINITE_CODE_OF_CONDUCT = "GET_INFINITE_CODE_OF_CONDUCT";

//ImageConduct
export const GET_IMAGE_OF_CONDUCT = "GET_IMAGE_OF_CONDUCT";
export const FIND_IMAGE_OF_CONDUCT = "FIND_IMAGE_OF_CONDUCT";
export const GET_INFINITE_IMAGE_OF_CONDUCT = "GET_INFINITE_IMAGE_OF_CONDUCT";

//Report
export const GET_TICKET_SALE_REPORT = "GET_TICKET_SALE_REPORT";
export const GET_TOURIST_BY_NATIONALITY_REPORT = "GET_TOURIST_BY_NATIONALITY_REPORT";
export const GET_TOURIST_BY_AGENT_REPORT = "GET_TOURIST_BY_AGENT_REPORT";
export const GET_TOURIST_EACH_TEMPLE_REPORT = "GET_TOURIST_EACH_TEMPLE_REPORT";
export const GET_FEEDBACK_REPORT = "GET_FEEDBACK_REPORT";
export const GET_INFINITE_FEEDBACK_REPORT = "GET_INFINITE_FEEDBACK_REPORT";
export const GET_PROFILE_NATIONAL_VISITOR_REPORT = "GET_PROFILE_NATIONAL_VISITOR_REPORT";
export const GET_PROFILE_NATIONAL_VISITOR_PRINT_REPORT = "GET_PROFILE_NATIONAL_VISITOR_PRINT_REPORT";
export const GET_INFINITE_PROFILE_NATIONAL_VISITOR_REPORT = "GET_INFINITE_PROFILE_NATIONAL_VISITOR_REPORT";

export const FIND_TOURIST_EACH_TEMPLE_REPORT =
  "FIND_TOURIST_EACH_TEMPLE_REPORT";
export const GET_TOURIST_EACH_TEMPLE_REPORT_REPORT =
  "GET_TOURIST_EACH_TEMPLE_REPORT_REPORT";

export const FIND_VISITOR = "FIND_VISITOR";
export const GET_VISITOR = "GET_VISITOR";
export const GET_VISITOR_REPORT = "GET_VISITOR_REPORT";

export const GET_PURPOSE_OF_VISIT = "GET_PURPOSE_OF_VISIT";
export const GET_INFINITE_PURPOSE_OF_VISIT = "GET_INFINITE_PURPOSE_OF_VISIT";
export const FIND_PURPOSE_OF_VISIT = "FIND_PURPOSE_OF_VISIT";

export const GET_TRANSPORTATION = "GET_TRANSPORTATION";
export const GET_INFINITE_TRANSPORTATION = "GET_INFINITE_TRANSPORTATION";
export const FIND_TRANSPORTATION = "FIND_TRANSPORTATION";

export const FIND_FEED_BACK = "FIND_FEED_BACK";
export const GET_FEED_BACK = "GET_FEED_BACK";
export const GET_FEED_BACK_REPORT = "GET_FEED_BACK_REPORT";

export const GET_MODULE_TYPE = "GET_MODULE_TYPE";

export const GET_INFINITE_EMPLOYEES = "GET_INFINITE_EMPLOYEES";
export const FIND_EMPLOYEE = "FIND_EMPLOYEE";
export const FIND_EMPLOYEE_HISTORY = "FIND_EMPLOYEE_HISTORY";
export const GET_EMPLOYEES = "GET_EMPLOYEE";
export const GET_EMPLOYEE_STATUS = "GET_EMPLOYEE_STATUS";

//Dropdown
export const GET_USER_DROPOWN = "GET_USER_DROPOWN";
export const GET_ICON_DROPOWN = "GET_ICON_DROPOWN";
export const GET_REGION_DROPDOWN = "GET_REGION_DROPDOWN";
export const GET_TEMPLE_DROPOWN = "GET_TEMPLE_DROPOWN";
export const GET_TEMPLE_GROUP_DROPOWN = "GET_TEMPLE_GROUP_DROPOWN";
export const GET_ZONE_DROPOWN = "GET_ZONE_DROPOWN";
export const GET_PROVINCE_DROPOWN = "GET_PROVINCE_DROPOWN";
export const GET_PURPOSE_OF_VISIT_DROPOWN = "GET_PURPOSE_OF_VISIT_DROPOWN";
export const GET_TRANSPORTATION_DROPOWN = "GET_TRANSPORTATION_DROPOWN";
export const GET_TYPE_OF_FEEDBACK_DROPOWN = "GET_TYPE_OF_FEEDBACK_DROPOWN";
export const GET_NATIONALITY_DROPOWN = "GET_NATIONALITY_DROPOWN";

//National Dashboard
export const GET_TOTAL_NATIONAL_TOURIST = "GET_TOTAL_NATIONAL_TOURIST";
export const GET_NATIONAL_TOURIST_BY_PROVINCE = "GET_NATIONAL_TOURIST_BY_PROVINCE";
export const GET_NATIONAL_TOURIST_BY_AGE = "GET_NATIONAL_TOURIST_BY_AGE";
export const GET_NATIONAL_TOURIST_BY_DURATION = "GET_NATIONAL_TOURIST_BY_DURATION";
export const GET_NATIONAL_TOURIST_BY_PURPOSE_OF_VISIT = "GET_NATIONAL_TOURIST_BY_PURPOSE_OF_VISIT";
export const GET_NATIONAL_TOURIST_BY_TRANSPORTATION = "GET_NATIONAL_TOURIST_BY_TRANSPORTATION";
export const GET_NATIONAL_TOURIST_BY_ZONE = "GET_NATIONAL_TOURIST_BY_ZONE";
export const GET_NATIONAL_AND_INTERNATIONAL_TOURIST = "GET_NATIONAL_AND_INTERNATIONAL_TOURIST";

//Internation Dashboard
export const GET_INTERNATION_TICKET_AND_REVENUE_THIS_MONTH = "GET_INTERNATION_TICKET_AND_REVENUE_THIS_MONTH";
export const GET_INTERNATION_TOURIST_REVENUE_TYPE = "GET_INTERNATION_TOURIST_REVENUE_TYPE";
export const GET_INTERNATION_TOURIST_BY_YEAR = "GET_INTERNATION_TOURIST_BY_YEAR";
export const GET_INTERNATION_REVENUE_BY_YEAR = "GET_INTERNATION_REVENUE_BY_YEAR";
export const GET_INTERNATION_TOURIST_BY_DAY = "GET_INTERNATION_TOURIST_BY_DAY";
export const GET_INTERNATION_TOURIST_BY_NATIONALITY = "GET_INTERNATION_TOURIST_BY_NATIONALITY";
export const GET_INTERNATION_TOURIST_BY_GROUP_AGE = "GET_INTERNATION_TOURIST_BY_GROUP_AGE";
export const GET_INTERNATION_TOURIST_FIT_GIT = "GET_INTERNATION_TOURIST_FIT_GIT";
export const GET_INTERNATION_TOURIST_BY_REGION = "GET_INTERNATION_TOURIST_BY_REGION";
export const GET_INTERNATION_TOURIST_BY_TEMPLE = "GET_INTERNATION_TOURIST_BY_TEMPLE";
export const GET_INTERNATION_TICKET_BY_MONTH = "GET_INTERNATION_TICKET_BY_MONTH";
export const GET_INTERNATION_REVENUE_BY_MONTH = "GET_INTERNATION_REVENUE_BY_MONTH";

//International Online Dashboard
export const GET_INTERNATION_TICKET_AND_REVENUE_BY_TICKET_TYPE = "GET_INTERNATION_TICKET_AND_REVENUE_BY_TICKET_TYPE";
export const GET_INTERNATIONAL_ONLINE_TOURIST_AND_STAND_TOURIST = "GET_INTERNATIONAL_ONLINE_TOURIST_AND_STAND_TOURIST";
export const GET_INTERNATIONAL_ONLINE_TOURIST_AND_STAND_TOURIST_BY_TICKET_TYPE = "GET_INTERNATIONAL_ONLINE_TOURIST_AND_STAND_TOURIST_BY_TICKET_TYPE";

//User Delete Request
export const GET_USER_DELETE_REASON_DROPOWN = "GET_USER_DELETE_REASON_DROPOWN";
export const GET_INFINITE_USER_DELETE_REQUEST = "GET_INFINITE_USER_DELETE_REQUEST";


//form Scan API Query Key
export const GET_PROVINCE_SCAN_DROPOWN = "GET_PROVINCE_SCAN_DROPOWN";
export const GET_DURATION_SCAN_DROPOWN = "GET_DURATION_SCAN_DROPOWN";
export const GET_TRANSPORTATION_SCAN_DROPOWN = "GET_TRANSPORTATION_SCAN_DROPOWN";
export const GET_PURPOSE_SCAN_DROPOWN = "GET_PURPOSE_SCAN_DROPOWN";

//Temple QR Panel
export const GET_TEMPLE_QR_PANEL = "GET_TEMPLE_QR_PANEL";
export const FIND_TEMPLE_QR_PANEL = "FIND_TEMPLE_QR_PANEL";
export const GET_INFINITE_TEMPLE_QR_PANEL = "GET_INFINITE_TEMPLE_QR_PANEL";
export const GET_TEMPLE_QR_PANEL_TYPE_DROPDOWN = "GET_TEMPLE_QR_PANEL_TYPE_DROPDOWN";

